import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { User } from '../../models/user';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  private returnUrl: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router) {

  }

  /**
   * urlIsLogin variable of login component.
   * If the url in the router is login then urlIsLogin = true
   * @type Boolean
   */
  public urlIsLogin = false;

  ngOnInit() {

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    // Add event listener for enter button
    var input = document.getElementById("password");

    input.addEventListener("keyup", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById("connect").click();
      }
    });

    if (this.router.url === 'login') this.urlIsLogin = true;
  }
}
